import { render, staticRenderFns } from "./FieldBoolean.vue?vue&type=template&id=22eba584&scoped=true&"
import script from "./FieldBoolean.vue?vue&type=script&lang=js&"
export * from "./FieldBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eba584",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22eba584')) {
      api.createRecord('22eba584', component.options)
    } else {
      api.reload('22eba584', component.options)
    }
    module.hot.accept("./FieldBoolean.vue?vue&type=template&id=22eba584&scoped=true&", function () {
      api.rerender('22eba584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldBoolean.vue"
export default component.exports